import { UserDetailsDto } from './../../../../data/models/dto/user-details.dto';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-parents-details',
  templateUrl: './parents-details.component.html',
  styleUrls: ['./parents-details.component.scss']
})
export class ParentsDetailsComponent {

  @Input() user?: UserDetailsDto
}
